import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { RegisterNodeInjectionKey, UnregisterNodeInjectionKey } from "game/layers";
import { computed, inject, onUnmounted, ref, toRefs, unref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const _props = __props as { id: string }


const props = toRefs(_props);

const register = inject(RegisterNodeInjectionKey);
const unregister = inject(UnregisterNodeInjectionKey);

const node = ref<HTMLElement | null>(null);
const parentNode = computed(() => node.value && node.value.parentElement);

if (register && unregister) {
    watch([parentNode, props.id], ([newNode, newID], [prevNode, prevID]) => {
        if (prevNode) {
            unregister(unref(prevID));
        }
        if (newNode) {
            register(newID, newNode);
        }
    });

    onUnmounted(() => unregister(unref(props.id)));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "node",
    ref_key: "node",
    ref: node
  }, null, 512))
}
}

})